import React from "react";
import styles from "./styles.module.css";
import { 
  FaEnvelope, 
  FaInfoCircle, 
  FaQuestionCircle, 
  FaWhatsapp 
} from "react-icons/fa";

const HomePage = () => {
  return (
    <main className={styles.container}>
      <section className={styles.hero}>
        <h1>Bem-vindo ao Voto Visão</h1>
        <p>
          Um espaço dedicado à <strong>análise</strong> dos dados eleitorais
          do Brasil. Aqui, você poderá acompanhar tendências, consultar dados e
          explorar relatórios — tudo de forma intuitiva.
        </p>
      </section>
    </main>
  );
};

export default HomePage;
